export const AWARDS_QUERY_KEY = "awards";
export const CERTIFICATIONS_QUERY_KEY = "certifications";
export const LANGUAGES_QUERY_KEY = "languages";
export const WORK_EXPERIENCE_QUERY_KEY = "employments";
export const EDUCATION_QUERY_KEY = "educations";
export const PREFERENCE_QUERY_KEY = "job_preferences";
export const PERSONAL_QUERY_KEY = "personal_details";
export const MASTER_QUERY_KEY = "master_data";
export const APPLIED_JOB_STATUS_QUERY_KEY = "applied_job_status";
export const APPLIED_JOBS_QUERY_KEY = "applied_jobs_data";
export const RESOLVE_AB_VARIANT_KEY = "resolve_ab_variant_data";
export const RECOMMENDED_JOBS_QUERY_KEY = "recommended_jobs_data";
export const SAVED_JOBS_QUERY_KEY = "saved_jobs_data";
export const SIMILAR_JOBS_QUERY_KEY = "similar_jobs_data";
export const JOB_DETAILS_QUERY_KEY = "job_details";
export const GET_AUTO_APPLY_QUERY_KEY = "get_auto_apply_data";
export const GET_VALIDATE_PROFILE_QUERY_KEY = "get_validate_profile_data";
export const PROFILE_SUMMARY_QUERY_KEY = "additional_profiles ";
export const PROJECTS_QUERY_KEY = "projects";
export const RESUME_QUERY_KEY = "resume";
export const BANNER_QUERY_KEY = "banner";
export const PROFILE_STATS_QUERY_KEY = "profile_stats";
export const SOCIAL_PRESENCE_QUERY_KEY = "social_presence";
export const WORK_SAMPLE_QUERY_KEY = "work_sample";
export const HEADER_QUERY_KEY = "header_data";
export const FOOTER_QUERY_KEY = "footer_data";
export const VALIDATE_PROFILE_QUERY_KEY = "validate_profile";
export const SKILLS_QUERY_KEY = "skills";
export const SUGGESTED_KEYWORDS = "suggested_keywords";
export const AI_SUMMARY = "ai_summary";
export const PROFILE_QUERY_KEY = "profile";

export type QueryKeys =
  | typeof AWARDS_QUERY_KEY
  | typeof CERTIFICATIONS_QUERY_KEY
  | typeof LANGUAGES_QUERY_KEY
  | typeof WORK_EXPERIENCE_QUERY_KEY
  | typeof EDUCATION_QUERY_KEY
  | typeof PREFERENCE_QUERY_KEY
  | typeof PERSONAL_QUERY_KEY
  | typeof MASTER_QUERY_KEY
  | typeof PROFILE_SUMMARY_QUERY_KEY
  | typeof PROJECTS_QUERY_KEY
  | typeof RESUME_QUERY_KEY
  | typeof BANNER_QUERY_KEY
  | typeof PROFILE_STATS_QUERY_KEY
  | typeof SOCIAL_PRESENCE_QUERY_KEY
  | typeof WORK_SAMPLE_QUERY_KEY
  | typeof HEADER_QUERY_KEY
  | typeof VALIDATE_PROFILE_QUERY_KEY
  | typeof SKILLS_QUERY_KEY
  | typeof SUGGESTED_KEYWORDS
  | typeof AI_SUMMARY
  | typeof PROFILE_QUERY_KEY;
